// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.MainStatusDialogue_dialogueBox__Iga2b {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  flex-shrink: 0;
  border-radius: 8px;
  background: var(--background-secondary, #fff);
  /* ◻️ Light/action_shadow */
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.05);
  z-index: 1000;
  padding: 20px;
}

.MainStatusDialogue_topHeading__Srli1 {
  color: var(--text-primary, #1f2023);
  /* Subheadline/Bold */
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 125% */
  letter-spacing: -0.5px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}
.MainStatusDialogue_topHeading__Srli1 span {
  display: flex;
  gap: 10px;
}

.MainStatusDialogue_toggleBox__ynaqN {
  display: flex;
  width: 100%;
  padding: 12px 16px;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  background: var(--background-quaternary, #f7f9fc);
  color: var(--text-primary, #1f2023);
  /* Body/Regular */
  font-family: Poppins;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 133.333% */
  letter-spacing: -0.5px;
  margin-bottom: 15px;
}

.MainStatusDialogue_plusIcon__pOFuO {
  border-radius: 32px;
  border: 1px solid var(--border-secondary, #c8d3e0);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  cursor: pointer;
}

.MainStatusDialogue_fromStatus__nx94s {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--text-secondary, #5c6168);
  /* Body/Regular */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  letter-spacing: -0.5px;
  padding: 15px 15px;
  border-bottom: 1px solid var(--border-tertiary, #e3eaf2);
  position: relative;
}
.MainStatusDialogue_fromStatus__nx94s span {
  display: flex;
  gap: 5px;
}

.MainStatusDialogue_toStatus__kqg3w {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--text-secondary, #5c6168);
  /* Body/Regular */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  letter-spacing: -0.5px;
  margin-bottom: 20px;
  padding: 15px 15px;
  position: relative;
}
.MainStatusDialogue_toStatus__kqg3w span {
  display: flex;
  gap: 5px;
}

.MainStatusDialogue_btnBox__Yc\\+-c {
  display: flex;
  justify-content: end;
}
.MainStatusDialogue_btnBox__Yc\\+-c button {
  display: flex;
  padding: 7px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  background: var(--primary-default, #0c6dc7);
  color: var(--text-on-color, #fff);
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 138.462% */
  letter-spacing: -0.5px;
}

.MainStatusDialogue_closeBox__CZgJj {
  cursor: pointer;
}

.MainStatusDialogue_disabled__LqDnF {
  cursor: default;
  background: var(--primary-disabled, #c8d3e0) !important;
}

@media only screen and (max-width: 500px) {
  .MainStatusDialogue_dialogueBox__Iga2b {
    top: unset;
    bottom: 0;
    left: 0;
    transform: unset;
    width: 100%;
  }
  .MainStatusDialogue_btnBox__Yc\\+-c button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Sidecar/ActionsDialogue/MainStatusDialogue/MainStatusDialogue.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EAEA,YAAA;EAEA,cAAA;EACA,kBAAA;EACA,6CAAA;EAEA,2BAAA;EACA,gDAAA;EACA,aAAA;EAEA,aAAA;AAFD;;AAOA;EACC,mCAAA;EAEA,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,sBAAA;EAEA,aAAA;EACA,8BAAA;EAEA,mBAAA;AAPD;AASC;EACC,aAAA;EACA,SAAA;AAPF;;AAWA;EACC,aAAA;EACA,WAAA;EACA,kBAAA;EAGA,mBAAA;EACA,8BAAA;EAEA,kBAAA;EACA,iDAAA;EAEA,mCAAA;EAEA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;EAEA,mBAAA;AAdD;;AAiBA;EACC,mBAAA;EACA,kDAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,WAAA;EACA,YAAA;EACA,eAAA;AAhBD;;AAmBA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EAEA,qCAAA;EAEA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;EAGA,kBAAA;EAEA,wDAAA;EAEA,kBAAA;AAtBD;AAwBC;EACC,aAAA;EACA,QAAA;AAtBF;;AA0BA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EAEA,qCAAA;EAEA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;EAEA,mBAAA;EACA,kBAAA;EAEA,kBAAA;AA3BD;AA6BC;EACC,aAAA;EACA,QAAA;AA3BF;;AA+BA;EACC,aAAA;EACA,oBAAA;AA5BD;AA8BC;EACC,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EAEA,kBAAA;EACA,2CAAA;EAEA,iCAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;AA9BF;;AAiCA;EACC,eAAA;AA9BD;;AAgCA;EACC,eAAA;EACA,uDAAA;AA7BD;;AAgCA;EACC;IACC,UAAA;IACA,SAAA;IACA,OAAA;IACA,gBAAA;IACA,WAAA;EA7BA;EAiCA;IACC,WAAA;EA/BD;AACF","sourcesContent":[".dialogueBox {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\n\twidth: 400px;\n\t// height: 100%;\n\tflex-shrink: 0;\n\tborder-radius: 8px;\n\tbackground: var(--background-secondary, #fff);\n\n\t/* ◻️ Light/action_shadow */\n\tbox-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.05);\n\tz-index: 1000;\n\n\tpadding: 20px;\n\n\t// position: relative;\n}\n\n.topHeading {\n\tcolor: var(--text-primary, #1f2023);\n\n\t/* Subheadline/Bold */\n\tfont-family: Poppins;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 20px; /* 125% */\n\tletter-spacing: -0.5px;\n\n\tdisplay: flex;\n\tjustify-content: space-between;\n\n\tmargin-bottom: 30px;\n\n\tspan {\n\t\tdisplay: flex;\n\t\tgap: 10px;\n\t}\n}\n\n.toggleBox {\n\tdisplay: flex;\n\twidth: 100%;\n\tpadding: 12px 16px;\n\t// flex-direction: column;\n\t// align-items: flex-start;\n\talign-items: center;\n\tjustify-content: space-between;\n\n\tborder-radius: 8px;\n\tbackground: var(--background-quaternary, #f7f9fc);\n\n\tcolor: var(--text-primary, #1f2023);\n\n\t/* Body/Regular */\n\tfont-family: Poppins;\n\tfont-size: 15px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 20px; /* 133.333% */\n\tletter-spacing: -0.5px;\n\n\tmargin-bottom: 15px;\n}\n\n.plusIcon {\n\tborder-radius: 32px;\n\tborder: 1px solid var(--border-secondary, #c8d3e0);\n\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\twidth: 32px;\n\theight: 32px;\n\tcursor: pointer;\n}\n\n.fromStatus {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\n\tcolor: var(--text-secondary, #5c6168);\n\n\t/* Body/Regular */\n\tfont-family: Poppins;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 20px; /* 142.857% */\n\tletter-spacing: -0.5px;\n\n\t// margin-bottom: 20px;\n\tpadding: 15px 15px;\n\n\tborder-bottom: 1px solid var(--border-tertiary, #e3eaf2);\n\n\tposition: relative;\n\n\tspan {\n\t\tdisplay: flex;\n\t\tgap: 5px;\n\t}\n}\n\n.toStatus {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\n\tcolor: var(--text-secondary, #5c6168);\n\n\t/* Body/Regular */\n\tfont-family: Poppins;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 20px; /* 142.857% */\n\tletter-spacing: -0.5px;\n\n\tmargin-bottom: 20px;\n\tpadding: 15px 15px;\n\n\tposition: relative;\n\n\tspan {\n\t\tdisplay: flex;\n\t\tgap: 5px;\n\t}\n}\n\n.btnBox {\n\tdisplay: flex;\n\tjustify-content: end;\n\n\tbutton {\n\t\tdisplay: flex;\n\t\tpadding: 7px 8px;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tgap: 4px;\n\n\t\tborder-radius: 8px;\n\t\tbackground: var(--primary-default, #0c6dc7);\n\n\t\tcolor: var(--text-on-color, #fff);\n\t\tfont-family: Poppins;\n\t\tfont-size: 13px;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tline-height: 18px; /* 138.462% */\n\t\tletter-spacing: -0.5px;\n\t}\n}\n.closeBox {\n\tcursor: pointer;\n}\n.disabled{\n\tcursor: default;\n\tbackground: var(--primary-disabled, #c8d3e0) !important;\n}\n\n@media only screen and (max-width: 500px) {\n\t.dialogueBox {\n\t\ttop: unset;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\ttransform: unset;\n\t\twidth: 100%;\n\t}\n\n\t.btnBox {\n\t\tbutton {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialogueBox": `MainStatusDialogue_dialogueBox__Iga2b`,
	"topHeading": `MainStatusDialogue_topHeading__Srli1`,
	"toggleBox": `MainStatusDialogue_toggleBox__ynaqN`,
	"plusIcon": `MainStatusDialogue_plusIcon__pOFuO`,
	"fromStatus": `MainStatusDialogue_fromStatus__nx94s`,
	"toStatus": `MainStatusDialogue_toStatus__kqg3w`,
	"btnBox": `MainStatusDialogue_btnBox__Yc+-c`,
	"closeBox": `MainStatusDialogue_closeBox__CZgJj`,
	"disabled": `MainStatusDialogue_disabled__LqDnF`
};
export default ___CSS_LOADER_EXPORT___;
